module.exports = __webpack_public_path__ + "static/media/Jinri Translated by J_Lee_77777.77fbe94c.md";